import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Link, TooltipTrigger, Tooltip, OverlayArrow } from "react-aria-components";
import * as style from "./Button.module.css";
import { getClassNameForSize, getClassNameForPadding, getClassNameForColor } from "./buttonUtils";
const LinkButton = ({
  size = "large",
  padding = "default",
  color = "primary",
  filled = false,
  disabled = false,
  label,
  href,
  target,
  className,
  children,
  tooltip,
  tooltipPosition = "top",
  tooltipCrossOffset = 0
}) => {
  const classes = classNames(className, style.button, getClassNameForSize(size), getClassNameForPadding(padding, size), getClassNameForColor(color), {
    [style.filled]: filled
  });
  if (tooltip) {
    return /* @__PURE__ */jsxs(TooltipTrigger, {
      delay: 0,
      closeDelay: 0,
      children: [/* @__PURE__ */jsx(Link, {
        href: disabled ? void 0 : href,
        target,
        className: classNames(classes, {
          [style.disabled]: disabled
        }),
        "aria-label": label,
        children
      }), /* @__PURE__ */jsxs(Tooltip, {
        className: style.tooltip,
        crossOffset: tooltipCrossOffset,
        placement: tooltipPosition,
        children: [/* @__PURE__ */jsx(OverlayArrow, {
          className: style.overlayArrow,
          children: /* @__PURE__ */jsx("svg", {
            width: 12,
            height: 12,
            viewBox: "0 0 12 12",
            children: /* @__PURE__ */jsx("path", {
              d: "M0 0 L6 6 L12 0"
            })
          })
        }), tooltip]
      })]
    });
  }
  return /* @__PURE__ */jsx(Link, {
    href: disabled ? void 0 : href,
    target,
    className: classes,
    "aria-label": label,
    isDisabled: disabled,
    children
  });
};
export default LinkButton;